module.exports = __webpack_public_path__ + "7f838342e3ce0507cf4d1420dec98ee9.png";